"use client"

import { useMemo } from "react"
import { CommandAction } from "@/contexts/command-palette-context"

import { useGlobalActions } from "@/hooks/use-global-actions"

export function useGlobalCommandActions(): CommandAction[] {
  const globalActions = useGlobalActions()

  return useMemo<CommandAction[]>(
    () => [
      {
        id: "action-create-task",
        label: "Create task",
        type: "task",
        keywords: ["new", "task", "create", "todo", "add"],
        footerText: "Create a new task",
        priority: 200,
        action: globalActions["create-task"],
        shortcut: {
          keys: "c t",
          formatted: ["c", "t"],
        },
      },
      {
        id: "create-client",
        label: "Create client",
        type: "task",
        keywords: ["new", "client", "create", "add", "customer"],
        footerText: "Create a new client",
        priority: 199,
        action: globalActions["create-client"],
        shortcut: {
          keys: "c c",
          formatted: ["c", "c"],
        },
      },
      {
        id: "create-prospect",
        label: "Create prospect",
        type: "task",
        keywords: ["new", "prospect", "create", "add", "lead"],
        footerText: "Create a new prospect",
        priority: 199,
        action: globalActions["create-prospect"],
        shortcut: {
          keys: "c p",
          formatted: ["c", "p"],
        },
      },
      {
        id: "create-contact",
        label: "Create contact",
        type: "task",
        keywords: ["new", "contact", "create", "add", "person"],
        footerText: "Create a new contact",
        priority: 199,
        action: globalActions["create-contact"],
        shortcut: {
          keys: "c o",
          formatted: ["c", "o"],
        },
      },
      {
        id: "action-compose-email",
        label: "Compose email",
        type: "task",
        keywords: ["new", "email", "compose", "send", "write", "mail"],
        footerText: "Compose a new email",
        priority: 198,
        action: globalActions["compose-email"],
        shortcut: {
          keys: "c e",
          formatted: ["c", "e"],
        },
      },
      // {
      //   id: "nav-home",
      //   label: "Go home",
      //   type: "navigation",
      //   keywords: ["home", "dashboard", "main"],
      //   footerText: "Go to assistant",
      //   priority: 100,
      //   action: globalActions["go-to-home"],
      //   shortcut: {
      //     keys: "g h",
      //     formatted: ["g", "h"],
      //   },
      // },
      // {
      //   id: "nav-book-settings",
      //   label: "Go to book settings",
      //   type: "navigation",
      //   keywords: ["book", "settings", "book settings"],
      //   footerText: "Go to book settings",
      //   priority: 90,
      //   action: globalActions["go-to-book-settings"],
      //   shortcut: {
      //     keys: "g s",
      //     formatted: ["g", "s"],
      //   },
      // },
      // {
      //   id: "nav-clients",
      //   label: "Go to clients",
      //   type: "navigation",
      //   keywords: ["clients", "customers"],
      //   footerText: "Go to clients",
      //   priority: 89,
      //   action: globalActions["go-to-clients"],
      //   shortcut: {
      //     keys: "g c",
      //     formatted: ["g", "c"],
      //   },
      // },
      // {
      //   id: "nav-prospects",
      //   label: "Go to prospects",
      //   type: "navigation",
      //   keywords: ["prospects", "leads"],
      //   footerText: "Go to prospects",
      //   priority: 88,
      //   action: globalActions["go-to-prospects"],
      //   shortcut: {
      //     keys: "g p",
      //     formatted: ["g", "p"],
      //   },
      // },
      // {
      //   id: "nav-contacts",
      //   label: "Go to contacts",
      //   type: "navigation",
      //   keywords: ["contacts", "people", "other"],
      //   footerText: "Go to contacts",
      //   priority: 87,
      //   action: globalActions["go-to-contacts"],
      //   shortcut: {
      //     keys: "g o",
      //     formatted: ["g", "o"],
      //   },
      // },
      // {
      //   id: "nav-opportunities",
      //   label: "Go to opportunities",
      //   type: "navigation",
      //   keywords: ["opportunities", "deals", "pipeline"],
      //   footerText: "Go to opportunities",
      //   priority: 86,
      //   action: globalActions["go-to-opportunities"],
      //   shortcut: {
      //     keys: "g d",
      //     formatted: ["g", "d"],
      //   },
      // },
      // {
      //   id: "nav-projects",
      //   label: "Go to projects",
      //   type: "navigation",
      //   keywords: ["projects", "work"],
      //   footerText: "Go to projects",
      //   priority: 85,
      //   action: globalActions["go-to-projects"],
      //   shortcut: {
      //     keys: "g j",
      //     formatted: ["g", "j"],
      //   },
      // },
      // {
      //   id: "nav-tasks",
      //   label: "Go to tasks",
      //   type: "navigation",
      //   keywords: ["tasks", "todos", "checklist"],
      //   footerText: "Go to tasks",
      //   priority: 84,
      //   action: globalActions["go-to-tasks"],
      //   shortcut: {
      //     keys: "g t",
      //     formatted: ["g", "t"],
      //   },
      // },
      // {
      //   id: "nav-meetings",
      //   label: "Go to meetings",
      //   type: "navigation",
      //   keywords: ["meetings", "calendar", "events"],
      //   footerText: "Go to meetings",
      //   priority: 83,
      //   action: globalActions["go-to-meetings"],
      //   shortcut: {
      //     keys: "g m",
      //     formatted: ["g", "m"],
      //   },
      // },
      // {
      //   id: "nav-sequences",
      //   label: "Go to sequences",
      //   type: "navigation",
      //   keywords: ["sequences", "automation", "drip"],
      //   footerText: "Go to sequences",
      //   priority: 81,
      //   action: globalActions["go-to-sequences"],
      //   shortcut: {
      //     keys: "g q",
      //     formatted: ["g", "q"],
      //   },
      // },
    ],
    [globalActions]
  )
}
